import {
  TRUSTED_SENDER_STATUS_NOT_CONFIRMED,
  TRUSTED_SENDER_STATUS_CONFIRMED,
  TRUSTED_SENDER_STATUS_BLOCKED,
  TRUSTED_SENDER_STATUS_TO_BE_CONFIRMED
} from 'Api/beSMSSendApi'
import {
  TRUSTED_SMS_INPUT_VARIANT_SUCCESS,
  TRUSTED_SMS_INPUT_VARIANT_UNVERIFIED,
  TRUSTED_SMS_INPUT_VARIANT_VERIFICATION,
  TRUSTED_SMS_INPUT_VARIANT_BLOCKED
} from 'mailup-web-components'

const mapStatusToVariant = (status) => {
  switch (status) {
    case TRUSTED_SENDER_STATUS_NOT_CONFIRMED:
      return TRUSTED_SMS_INPUT_VARIANT_UNVERIFIED
    case TRUSTED_SENDER_STATUS_BLOCKED:
      return TRUSTED_SMS_INPUT_VARIANT_BLOCKED
    case TRUSTED_SENDER_STATUS_CONFIRMED:
      return TRUSTED_SMS_INPUT_VARIANT_SUCCESS
    case TRUSTED_SENDER_STATUS_TO_BE_CONFIRMED:
      return TRUSTED_SMS_INPUT_VARIANT_VERIFICATION
  }
}

export default mapStatusToVariant
